import * as urls from "../../../api/urls";
import { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import MasterPage1Column from "pages/MasterPage1Column";
import Select, { components, useStateManager } from 'react-select';
import { useRedux } from "hooks";
import { createSelector } from "reselect";


const GeneralSettingComponent: React.FC<{}> = ({ }) => {
  const { dispatch, useAppSelector } = useRedux();
  const [ddlUser, setDdlUser] = useState<any[]>([]);
  const [userToAddRemove, setUserToAddRemove] = useState<any[]>([]);

  const storeData = createSelector(
    (state: any) => state.Profile2,
    (p2) => ({
      isAdmin: p2.isAdmin,
    })
  );
  const { isAdmin } = useAppSelector(storeData);


  useEffect(() => {
    const rs = new APIClient().fnPostForm(urls.SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL, {})
      .then(rs => {
        // console.log('SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL:', rs);
        setDdlUser(rs);
      })
      .catch(er => Utils.HandleException(er, true));

    const rs2 = new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setUserToAddRemove(forDll);
      }).catch(er => Utils.HandleException(er, true));
  }, []);

  const onSave2sOnline = () => {
    try {
      const userId = userToAddRemove.map((x: any) => x.value);
      if (userId.length <= 0) {
        alert('ไม่มีข้อมูล');
      } else {
        new APIClient().fnPostForm(urls.SAVE_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE, { userIds: userId })
          .then(rs => alert('บันทึกสำเร็จ'))
          .catch(er => Utils.HandleException(er, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return (
    <>
      <div className="row">
        <div className="col">
          พนักงานเข้าห้องแชท 2sonline กรณีลูกค้าใหม่
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                className="form-control"
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setUserToAddRemove(e)}
                value={userToAddRemove}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={onSave2sOnline}>Save</button>
            }
          </div>
        </div>
      </div >
    </>
  )
}

const DataSettingGeneral = () => {
  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
  }

  return (
    <MasterPage1Column
      titleText="กำหนดค่าการทำงานทั่วไป"
      titleIcon="fa fa-gears"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<GeneralSettingComponent />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingGeneral;